import IProject from "common/interfaces/IProject";
import IRole from "common/interfaces/IRole";

export const isMember = (project?: IProject, userId?: string): boolean => {
  if (!project || !userId) return false;
  const member = project?.roles?.find((role) => role.userId?._id === userId);
  return member !== undefined || isOwner(project, userId);
};

export const isOwner = (project?: IProject, userId?: string): boolean => {
  if (!project || !userId) return false;
  return project.owner === userId;
};

export const hasMembers = (project?: IProject): boolean => {
  const member = project?.roles?.find((role) => role.userId);
  return member !== undefined;
};

export const hasApplications = (roles?: IRole[]): boolean => {
  const rolesWithApplications = roles?.filter(
    (role) => role.applicants?.length > 0
  );
  if (!rolesWithApplications) return false;
  return rolesWithApplications.length > 0;
};

export const getOpenRoleNames = (project: IProject): string[] => {
  if (project?.roles) {
    return project?.roles
      ?.filter((role) => !role.userId)
      ?.map((role) => role.name);
  }
  return [];
};

export const getOpenRoles = (project: IProject): IRole[] => {
  if (project?.roles) {
    return project?.roles?.filter((role) => !role.userId);
  }
  return [];
};
